import { Input, InputProps, Select, SelectProps } from 'antd';
import cls from 'classnames';
import React from 'react';

import { useLocaleComponent } from '../../hooks/use-locale';
import { usePrefixCls } from '../../hooks/use-prefix-cls';

import phoneCodeOptions from './country-code-and-phone-code.json';
import useStyle from './style';

interface PhoneWithPrefixValue {
  phonePrefix: string;
  phone: string;
}

interface PrefixPhoneSelectProps {
  value: PhoneWithPrefixValue;
  onChange: (value: PhoneWithPrefixValue) => void;
  disabled?: boolean;
  className?: string;
}

export const PrefixPhoneSelect = (props: PrefixPhoneSelectProps) => {
  const { value, onChange, disabled = false } = props;
  const locale = useLocaleComponent('PrefixPhoneSelect');
  const prefixCls = usePrefixCls('formily-prefix-phone-select');
  const [wrapSSR, hashId] = useStyle(prefixCls);

  const triggerChange = (changedValue: Partial<PhoneWithPrefixValue>) => {
    onChange?.({ ...value, ...changedValue });
  };

  const onPhonePrefixChange: SelectProps['onChange'] = (phonePrefix) => {
    triggerChange({ phonePrefix: phonePrefix as string });
  };

  const optionRender: SelectProps['optionRender'] = option => `+${option.value} ${option.label}`;

  const labelRender: SelectProps['labelRender'] = props => `+${props.value}`;

  const prefixSelector = (
    <Select
      showSearch
      className={`${prefixCls}-prefix`}
      disabled={disabled}
      fieldNames={{
        label: locale.countryNameField,
        value: 'phone_code',
      }}
      labelRender={labelRender}
      optionFilterProp={locale.countryNameField}
      optionRender={optionRender}
      options={phoneCodeOptions}
      popupMatchSelectWidth={false}
      value={value?.phonePrefix}
      onChange={onPhonePrefixChange}
    />
  );

  const onPhoneChange: InputProps['onChange'] = (e) => {
    triggerChange({ phone: e.target.value });
  };

  return wrapSSR(
    <Input
      addonBefore={prefixSelector}
      className={cls(prefixCls, hashId, props.className)}
      disabled={disabled}
      placeholder={locale.placeholder}
      value={value?.phone}
      onChange={onPhoneChange}
    />,
  );
};
